import { CharacterPack } from "./types";

export const santaReindeerPack: CharacterPack = {
  name: "Santa’s Reindeer",
  description: "The legendary reindeer who pull Santa Claus’ sleigh.",
  characters: [
    { name: "Dasher", description: "Known for his incredible speed." },
    { name: "Dancer", description: "Graceful and light on his hooves." },
    { name: "Prancer", description: "Proud and elegant flyer." },
    { name: "Vixen", description: "Clever and spirited reindeer." },
    { name: "Comet", description: "Blazes across the sky like a comet." },
    { name: "Cupid", description: "Spreads love and holiday cheer." },
    { name: "Donner", description: "Powerful and thunderous." },
    { name: "Blitzen", description: "Fast as lightning." },
    { name: "Rudolph", description: "Famous for his glowing red nose." },
  ],
};
